import { Stack, Typography } from '@mui/material'
import { form } from '../../formState'
import { useTexts } from './useTexts'

export function SummarizeFutureMobileRoute() {
  const texts = useTexts()

  return (
    <Stack>
      <form.BulkCheckbox
        name="summarizeFutureMobileRoute"
        testId="summarizeFutureMobileRoute"
        label={texts.summarizeFutureMobileRoute}
        validateOn="change"
      />
      <Typography
        variant="caption"
        sx={theme => ({ ml: 4, color: theme.vars.palette.text.secondary })}
      >
        {texts.summarizeFutureMobileRouteHelper}
      </Typography>
    </Stack>
  )
}
